import React, { ReactElement, useEffect, useState } from "react"
import Breadcrumb from "components/views/atoms/Breadcrumb"
import BreadcrumbsHeader from "components/views/atoms/BreadcrumbsHeader"
import { MasterLayout } from "components/views/atoms/layouts/MasterLayout"
import TwoColumnRightPrimary from "components/views/atoms/layouts/TwoColumnRightPrimary"
import { getTalkToCarrotProviderEligibilityGuidance } from "../../lib/contentful/contentfulClient"
import { useHistory } from "react-router"
import { GuidanceElement } from "../../lib/contentful/components/GuidanceElement"
import Guidance from "../../components/views/atoms/Guidance"
import { SendMessage } from "../../components/talk-to-carrot/send-message/SendMessage"
import { talkToCarrotSource } from "../../components/talk-to-carrot/send-message/SendMessageUtil"
import { TalkToCarrotLegal } from "../../components/talk-to-carrot/TalkToCarrotLegal"

const ProviderEligibility = ({ breadcrumbs, baseUrl }) => {
  const history = useHistory()
  const [guidance, setGuidance] = useState<ReactElement<typeof Guidance>>(null)
  const helpPath = `${baseUrl}/provider-eligibility`

  useEffect(() => {
    const loadGuidance = async () => {
      const guidance = await getTalkToCarrotProviderEligibilityGuidance()
      setGuidance(<GuidanceElement guidance={guidance} />)
    }
    if (!guidance) {
      loadGuidance()
    }
  }, [])

  return (
    <MasterLayout
      footer={<TalkToCarrotLegal />}
      header={
        <BreadcrumbsHeader
          breadcrumbs={[
            ...breadcrumbs,
            <Breadcrumb
              key="help-breadcrumb"
              title={"Check provider eligibility"}
              isActive
              onClick={() => history.push(helpPath)}
            />
          ]}
        />
      }
    >
      <TwoColumnRightPrimary
        secondaryContent={guidance}
        primaryContent={<SendMessage source={talkToCarrotSource.PROVIDER_ELIGIBILITY} />}
      />
    </MasterLayout>
  )
}

export { ProviderEligibility }
